<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-05-17 11:17:39
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-05-25 10:41:49
 * @FilePath: /dsicm-admin-web/src/views/scoentific/components/showText/index.vue
-->
<template>
    <div class="show-text">
        <header>
            <div></div>
            <span>{{listData.title}}</span>
        </header>
        <ul>
            <el-scrollbar style="height: 100%" wrap-style="overflow-x:hidden;">
                <li  style="margin-right:10px" v-for="(item,index) in listData.list" :key="index" >
                    <p>{{item.name}}</p>
                    <span v-if="!item.type">{{item.value}}</span>
                    <el-image 
                    v-if="item.type && item.value"
                    style="width: 100px; height: 100px;border-radius:6px"
                    :src="item.value" 
                    :preview-src-list="[item.value]"
                    >
                    </el-image>
                </li>
            </el-scrollbar>
        </ul>
    </div>
</template>
<script>
export default {
    name:'ShowText',
    props:{
        listData:{
            type:Object,
            default:() => {}
        }
    },
    data(){
        return{
            
        }
    }
}
</script>
<style lang="less" scoped>
.show-text{
    height: 75vh;
    background: #fff;
    padding: 18px;
    padding-top: 0;
    padding-right: 8px;
    box-sizing: border-box;
    border-radius: 6px;
    overflow: hidden;
    header{
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        div{
            width: 4px;
            height: 15px;
            background: #1A7BFC;
            margin-right: 12px;
        }
        span{
            font-size: 14px;
            font-weight: 700;
            color: rgba(0, 0, 0, 0.85);
            line-height: 22px;
        }
    }
    ul{
        height: 70vh;
        li{
            display: flex;
            margin-bottom: 30px;
            p{
                width: 125px;
                text-align: left;
                margin-right: 27px;
                font-size: 12px;
                color: #333333;
                line-height: 22px;
            }
            span{
                flex: 1;
                font-size: 12px;
                color: #333333;
                line-height: 22px;
            }
        }
    }
}
</style>